<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <SystemModulesList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import SystemModulesList from '@/components/settings/users/systemModules/SystemModulesList'

export default {
  name: 'SystemModules',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    SystemModulesList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addsystemmodule' })
    }
  }
}
</script>
